import { PaperclipIcon } from 'lucide-react'
import type { FC, ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface ChatInputAttachTriggerProps {
  isDisabled: boolean
  className?: string
}

/**
 * Trigger button for opening the attachment sheet.
 */
export const ChatInputAttachTrigger: FC<ChatInputAttachTriggerProps> = ({
  isDisabled,
  className,
}): ReactNode => (
  <Button
    type="button"
    variant="ghost"
    size="sm"
    disabled={isDisabled}
    className={cn('chat-input-attach-button gap-1.5', className)}
    aria-label="Add attachment"
  >
    <PaperclipIcon className="size-4" />
    <span className="hidden sm:inline">Attach</span>
  </Button>
)

ChatInputAttachTrigger.displayName = 'ChatInputAttachTrigger'
